var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3C0 1.34315 1.34315 0 3 0H29C30.6569 0 32 1.34315 32 3V29C32 30.6569 30.6569 32 29 32H3C1.34315 32 0 30.6569 0 29V3Z",
    fill: "#EAFCFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7099 23.4086L22.851 24.2675C22.3766 24.7419 21.6075 24.7418 21.1332 24.2675L13.6386 16.7729C13.6262 16.7605 13.6225 16.7438 13.6107 16.731C13.1631 16.8912 12.6877 16.9939 12.185 16.9939C9.83695 16.994 7.93359 15.0906 7.93359 12.7425C7.93359 12.0687 8.10471 11.44 8.38369 10.8739L11.3839 13.8741L13.3165 11.9415L10.3163 8.94129C10.8824 8.66223 11.5111 8.49112 12.1849 8.49112C14.533 8.49112 16.4364 10.3946 16.4363 12.7426C16.4363 13.2453 16.3336 13.7207 16.1734 14.1683C16.1862 14.18 16.2029 14.1838 16.2153 14.1962L23.7099 21.6907C24.1842 22.1651 24.1843 22.9342 23.7099 23.4086Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoIcon);
export default __webpack_public_path__ + "static/media/woIcon.6e162300c58751ba2a4d97b1d8f72dfa.svg";
export { ForwardRef as ReactComponent };